/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_translate_frame_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading frame`)
};

const es_translate_frame_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marco de lectura`)
};

const de_translate_frame_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leseraster`)
};

const nl_translate_frame_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leesframe`)
};

const fr_translate_frame_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadre de lecture`)
};

const it_translate_frame_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fase di lettura`)
};

const pt_br2_translate_frame_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quadro de leitura`)
};

const pt_translate_frame_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grelha de leitura`)
};

const ja_translate_frame_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み枠`)
};

const zh_translate_frame_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阅读框`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const translate_frame_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.translate_frame_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("translate_frame_label", locale)
	if (locale === "en") return en_translate_frame_label(inputs)
	if (locale === "es") return es_translate_frame_label(inputs)
	if (locale === "de") return de_translate_frame_label(inputs)
	if (locale === "nl") return nl_translate_frame_label(inputs)
	if (locale === "fr") return fr_translate_frame_label(inputs)
	if (locale === "it") return it_translate_frame_label(inputs)
	if (locale === "pt-BR") return pt_br2_translate_frame_label(inputs)
	if (locale === "pt") return pt_translate_frame_label(inputs)
	if (locale === "ja") return ja_translate_frame_label(inputs)
	return zh_translate_frame_label(inputs)
};